import { AppCodes, lddGlobalSessionInfo, MenuItemCategory, MenuItemType, NavObjectType, PopupPageId } from '../Components/navigationTypes';
import { Badge, Form, Nav, Navbar, Tab, ListGroup } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { RPWDataReader, getDataReader } from '../livedataFuncs'
import { navItem } from './navigationElement';
import { FileTabButton } from './fileTabButton';
import { CONST, ContractType, fileTabVal, FinanceType, MortgageType, PersonType, PurchaserType, RegistrationType } from './sideTypes';
import { getDetailsList } from './menus/details';
import { workspaceList } from './menus/workspace';
import { documentsList } from './menus/documents';
import { clientPortalList } from './menus/clientportal';
import { store } from '../redux/store';
import { useAppSelector } from '../redux/hooks';
import { lddStateObject } from '../redux/reducer';
import React from 'react';
import './sidedrawer.scss';
import EventQueueManager from '../lib/eventQueue';
import { builderConnectList } from './menus/newhome';
import { getNestedProperty } from '../util/rpwCommonFuncs';
import axios from 'axios';
import { DocsDropbox } from '../Components/MortgageAnalyzer/DocsDropbox';
import { DocumentSetup } from './DocumentSetup';

/** Convert DeliveryNotation HTML (e.g. with span[screenName]) to plain text for sidebar display,  */
function deliveryNotationToPlainText(htmlString: string): string {
    if (!htmlString) return '';
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const spans = doc.querySelectorAll('span[screenName]');
    spans.forEach(span => {
        const placeholder = span.getAttribute('screenName') || span.textContent || '';
        const text = document.createTextNode(placeholder);
        span.parentNode?.replaceChild(text, span);
    });
    let out = doc.body?.innerText || doc.body?.textContent || '';
    // Ensure space after "] " when segments are concatenated (e.g. "[Amount Owing From Broker]Delivered" -> "[Amount Owing From Broker] Delivered")
    out = out.replace(/\](\S)/g, '] $1');
    return out;
}

async function currentPageMenu(props: { page: NavObjectType, dataroot: any, filetab: fileTabVal }): Promise<Array<MenuItemType>> {
    const page: NavObjectType = props.page;
    let fileList = [];
    const appCodeShort = store?.getState()?.SessionInfo?.appProvinceShort;
    const appCode = store?.getState()?.SessionInfo?.appCode;
    const sid = store?.getState()?.SessionInfo?.sid;
    const processor: RPWDataReader = getDataReader(props.dataroot);

    const isCollege = store?.getState()?.SessionInfo?.firm?.IsCollege;

    switch (props.filetab) {
        case fileTabVal.SUMMARY:
            // fileList = (await getDetailsList(appCodeShort, sid, isCollege));
            break;
        case fileTabVal.DETAILS:
            fileList = await getDetailsList(appCodeShort, sid, isCollege);
            break;
        // case fileTabVal.WORKSPACE:
        //     fileList = workspaceList;
        //     break;
        case fileTabVal.DOCUMENTS:
            fileList = documentsList;
            break;
        case fileTabVal.CLIENTPORTAL:
            fileList = clientPortalList();
            break;
        case fileTabVal.NEWHOME:
            fileList = builderConnectList;
            break;
        default:
            fileList = [];
            break;
    }

    let menu: Array<MenuItemType> = [];
    let ProperMenu: Array<MenuItemType> = [];
    let PSM = props.dataroot ? processor.getPSM() : "";
    if (typeof page.url === "string") {
        if (page.url?.indexOf("appEditDispatch") > -1 && page.params?.PSM && page.params?.PSM.length > 0) {
            menu = menu.concat(initMenu(newFileMenu(fileList), page.params));
        }
        if (page.params && page.params['formasp'] === 'purfileedit') {
            let id: string;
            if (props.dataroot) {
                if (props.dataroot.selectSingleNode("ancestor-or-self::TPAppXML") !== undefined) {
                    id = props.dataroot.selectSingleNode("ancestor-or-self::TPAppXML").getAttribute("AppID");
                } else {
                    id = page.params.id;
                }
            } else {
                id = page.params.id;
            }
            menu = menu.concat(newFileMenu(fileList));
            if (props.dataroot) {
                switch (props.filetab) {
                    case fileTabVal.SUMMARY:
                        break;
                    case fileTabVal.DETAILS:
                        loadDetailsMenu(processor, menu, ProperMenu, id);
                        break;
                    case fileTabVal.DOCUMENTS:
                        ProperMenu = menu;
                        break;
                    case fileTabVal.CLIENTPORTAL:
                        loadClientPortalMenu(processor, menu, ProperMenu);
                        break;
                    case fileTabVal.NEWHOME:
                        ProperMenu = menu;
                        break;
                    default:
                        fileList = [];
                        break;
                }
            } else {
                return []
            }
            menu = initMenu(menu, { id: id, ...page.params });
            ProperMenu = initMenu(ProperMenu, { id: id, ...page.params });
        }

    }
    let returnMenu = filterAllMenuItemsNoMap(PSM, ProperMenu, validatePSM);
    returnMenu = filterAllMenuItems(appCode, returnMenu, validateAppCode)
    if (PSM) {
        returnMenu = filterAllMenuItems(PSM, returnMenu, validatePSM);
    }
    returnMenu = filterAllMenuItems(processor, returnMenu, validateRequiredFields);
    returnMenu = filterAllMenuItems([store?.getState()?.SessionInfo, 'firm'], returnMenu, validateSessionSource);
    return returnMenu
}

function loadClientPortalMenu(processor: RPWDataReader, menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>) {
    const clientConnect = menu.find(menuItem => menuItem.label === "ClientConnect");
    const remoteClosing = menu.find(menuItem => menuItem.label === "E-Signing");
    ProperMenu.push(clientConnect);

    const clientTasks = menu.find(menuItem => menuItem.label === "Client Tasks");
    
    const isSaleFile: boolean = processor.getPSM() === 'S';
    if (isSaleFile && clientTasks) {
        const filteredClientTasks = {
            ...clientTasks,
            subItems: clientTasks.subItems.filter(item => item.label !== "Source of Funds")
        };
        ProperMenu.push(filteredClientTasks);
    } else {
        ProperMenu.push(clientTasks);
    }

    ProperMenu.push(remoteClosing);
}

function findMenuItem(menu: Array<MenuItemType>, name: string): MenuItemType {
    return menu.find(menuItem => menuItem.label === name);
}

function loadWorkspaceMenu(processor: RPWDataReader, menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>): void {
    let PSM = processor.getPSM();
    const province = processor.getAppCode();
    let PSMDummy = processor.getPSMDummy();
    const isTitleTransfer: boolean = (PSMDummy === 'T' && province === 'BC');
    const diligence = menu.find(menuItem => menuItem.label === "Due Diligence")
    if (diligence) {
        /*const titleSearch = findMenuItem(diligence.subItems, "Title Search")
        const writSearch = findMenuItem(diligence.subItems, "Writ Search");
        const titleSearchData: Array<TitleSearchType> = processor.getTitleSearch()
        const writSearchData: Array<TitleSearchType> = processor.getTitleSearch()
        if (titleSearchData.length > 0) {
            titleSearch.params = { badgetext: drawerDateFormat(titleSearchData[0].date), badgetype: "active" };
        } else {
            titleSearch.params = { badgetext: "None", badgetype: "fail" };
        }
        if (writSearchData.length > 0) {
            writSearch.params = { badgetext: drawerDateFormat(writSearchData[0].date), badgetype: "active" };
        } else {
            writSearch.params = { badgetext: "None", badgetype: "fail" };
        }*/
        ProperMenu.push(diligence);
    }
    const titleInsuranceHeader = findMenuItem(menu, "Title Insurance");
    const titleSubItem = titleInsuranceHeader.subItems.find(menuItem => menuItem.type === MenuItemCategory.TitleInsurance);
    if (titleSubItem && validatePSM(PSM, titleInsuranceHeader)) {
        let titleInsuranceLabel = processor.getInsuranceInformation().insuranceProvider;
        if (titleInsuranceLabel && titleInsuranceLabel.length > 0) {
            titleSubItem.label = titleInsuranceLabel;
        } else {
            titleSubItem.label = "+ Title Insurance";
        }
        ProperMenu.push(titleInsuranceHeader);
    }
    const matterHeader = menu.find(menuItem => menuItem.id === "Matters")
    if (matterHeader) {
        loadMatterInfo(processor.getDefectInformation(), matterHeader);
        ProperMenu.push(matterHeader);
    }

    const requisitionHeader = menu.find(menuItem => menuItem.id === "Requisition")
    if (requisitionHeader) {
        loadMatterInfo(processor.getDefectInformation(), requisitionHeader);
        ProperMenu.push(requisitionHeader);
    }

    const objectionHeader = menu.find(menuItem => menuItem.id === "Objection")
    if (objectionHeader) {
        loadMatterInfo(processor.getDefectInformation(), objectionHeader);
        ProperMenu.push(objectionHeader);
    }

    const trustLetterMBHeader = menu.find(menuItem => menuItem.id === "TrustLetterMB")
    if (trustLetterMBHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterMBHeader);
        ProperMenu.push(trustLetterMBHeader);
    }

    const trustLetterSKHeader = menu.find(menuItem => menuItem.id === "TrustLetterSK")
    if (trustLetterSKHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterSKHeader);
        ProperMenu.push(trustLetterSKHeader);
    }

    const trustLetterHeader = menu.find(menuItem => menuItem.id === "TrustLetter")
    if (trustLetterHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterHeader);
        ProperMenu.push(trustLetterHeader);
    }

    const descriptionHeader = menu.find(menuItem => menuItem.id === "Description")
    if (descriptionHeader) {
        loadMatterInfo(processor.getDefectInformation(), descriptionHeader);
        ProperMenu.push(descriptionHeader);
    }

    const titleMemorandumResponseHeader = menu.find(menuItem => menuItem.id === "TitleMemorandum")
    if (titleMemorandumResponseHeader) {
        loadMatterInfo(processor.getDefectInformation(), titleMemorandumResponseHeader);
        ProperMenu.push(titleMemorandumResponseHeader);
    }

    if(!isTitleTransfer){
        const undertakingResponseHeader = menu.find(menuItem => menuItem.id === "Undertaking")
        if (undertakingResponseHeader) {
            loadMatterInfo(processor.getDefectInformation(), undertakingResponseHeader);
            ProperMenu.push(undertakingResponseHeader);
        }
    }

    const registration = menu.find(menuItem => menuItem.label === "Registration")
    if (registration) {
        let newSubItems: Array<MenuItemType> = processor.getRegistrationDetails().map(displayDefect);
        for (let i = 0; i < newSubItems.length; i++) {
            let s = newSubItems[i];
            registration.subItems.push(s);
        }
        ProperMenu.push(registration);
    }
}
function filterAllMenuItemsNoMap(checkParam: any, menu: Array<MenuItemType>, condition: (param: any, menuItem: MenuItemType) => boolean) {
    return menu
        .filter((menuItem) => condition(checkParam, menuItem))
}
function filterAllMenuItems(checkParam: any, menu: Array<MenuItemType>, condition: (param: any, menuItem: MenuItemType) => boolean): Array<MenuItemType> {
    return menu
        .filter((menuItem) => condition(checkParam, menuItem))
        .map((menuItem) => filterMenuItem(checkParam, menuItem, condition));
}
function filterMenuItem(checkParam: any, def: MenuItemType, condition: (param: any, menuItem: MenuItemType) => boolean): MenuItemType {
    if (def.subItems) {
        def.subItems = filterAllMenuItems(checkParam, def.subItems, condition)
    }
    if (def.addOptions) {
        def.addOptions = filterAllMenuItems(checkParam, def.addOptions, condition)
    }
    return def
}
function validateAppCode(currApp: AppCodes, def: MenuItemType): boolean {
    let ret = true;
    let condition = def.appCode;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            if (condition[i].toUpperCase() === currApp.toUpperCase()) {
                ret = true;
            }
        }
    }
    return ret;
}
function validatePSM(fileType, def: MenuItemType): boolean {
    let ret = true;
    let condition = def.PSM;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            let c = condition.charAt(i);
            if (c.toUpperCase() === fileType.toUpperCase()) {
                ret = true;
            }
        }
    }
    return ret;
}
function validateRequiredFields(processor: RPWDataReader, def: MenuItemType): boolean {
    let ret = true;
    const condition = def.requiredFields;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            const value = processor[condition[i].field]();
            if (condition[i].isNull) {
                return value === null;
            } else if (condition[i].value) {
                ret = value === condition[i].value;
            } else if (value) {
                ret = true;
            } else {
                return false;
            }
        }
    }
    return ret;
}

function validateSessionSource(session: [lddGlobalSessionInfo, string], def: MenuItemType): boolean {
    const property = session[1];
    const sessionInfo = (property && property > '' && session[0][property]) ? getNestedProperty(session[0], property) : session[0];
    let ret = true;
    const condition = def.requiredSessionFields;
    if (condition) {
        for (let i = 0; i < condition.length; i++){
            const value = sessionInfo[condition[i].field];
            if (typeof value === 'undefined' && typeof condition[i].value === "boolean" && condition[i].value === false) {
                return true;
            }
            if (typeof value === 'boolean' && !value && !condition[i].value) {
                return true;
            }
            if (typeof(value) !== 'boolean' || value !== condition[i].value) {
                ret = false;
            }
        }
    }
    return ret
}

function setIssueLabel(item: MenuItemType, PSM: "" | "P" | "S" | "M" | "O"): void {
    if(PSM === "S"){
        item.label = `Response to ${item.label}`;
    }
}

export const SolicitorNavigate: NavObjectType = {
    component: "main",
    url: "lfmaster.asp",
    params: {
        "tb": "TPAppXML",
        "formasp": "purfileedit",
        "id": CONST.uninitialized,
        "PSM": CONST.uninitialized,
    },
    controller: {
        tabName: PopupPageId.Solicitor,
    },
    label: "Solicitor",
}

export function getSolicitorLabel(province: string, PSM: string, isSet = false, isNotary = false): string {
    const prefix = PSM === "S"?"Buyer":"Seller"
    if(province === "BC"){
        if(!isSet) return `${prefix}'s Lawyer/Notary`;
        return `${prefix}'s ${isNotary?"Notary":"Lawyer"}`
    } else {
        return `${prefix}'s Lawyer`;
    }

}

function loadDetailsMenu(processor: RPWDataReader, menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>, id: string): void {
    let PSM = processor.getPSM();
    const province = processor.getAppCode();
    let PSMDummy = processor.getPSMDummy();
    const isTitleTransfer: boolean = (PSMDummy === 'T' && province === 'BC');
    let appCode = processor.getAppCode(); 
    ["Basic", "Contract"].forEach(label => {
        let item = menu.find(menuItem => menuItem.label === label);
        if(item && validatePSM(PSM, item)){
            ProperMenu.push(item);
        }
    })
    let property = menu.filter(menuItem => menuItem.label === "Property");
    property.forEach(item => {
        if (item && validatePSM(PSM, item)) {
            if (item.appCode?.includes("RPWBC") && item.subItems) {
                const extraPropertyCount = processor.getExtraPropertyNodesLength();
                item.subItems = item.subItems.map((subItem) => {
                    if (subItem.label === "Extra Properties") {
                        subItem.params = {
                            ...(subItem.params || {}),
                            badgetext: String(extraPropertyCount),
                        };
                    }
                    return subItem;
                });
            }
            ProperMenu.push(item);
        }
    })
    // let contractHeader = menu.find(menuItem => menuItem.label === "Contract")
    // if (contractHeader && validatePSM(PSM, contractHeader)) {
    //     let c = updateContract(processor, processor.getContractInformation(), contractHeader)
    //     ProperMenu.push(c);
    // }
    var otherSideLawyer = processor.getOtherSideLawyerName();

    const newSolicitor: MenuItemType = {
        label: "Solicitor",
        customLabel: getSolicitorLabel(province, PSM, otherSideLawyer > "", processor.otherSideLawyerIsNotary()),
        navigate: structuredClone(SolicitorNavigate),
        params: {
            badgetext: otherSideLawyer,
        },
        addOptions: [],
        type: MenuItemCategory.LawyerList,
        icon: "fa-scale-balanced",
    }

    let buyerHeader = menu.find(menuItem => menuItem.id === "Buyer");
    if (buyerHeader) {
        if (PSM === "M") {
            buyerHeader.label = "Borrower Side";
            const buyerInfo = processor.getMortgagorInformation();
            buyerHeader.subItems = buyerInfo.map((val, index) => displayPurchaser(val, index, buyerInfo.length));
        } else {
            const buyerInfo = processor.getBuyerPeopleInfo();
            buyerHeader.subItems = buyerInfo.map((val, index) => displayPurchaser(val, index, buyerInfo.length));
        }
        if (isTitleTransfer && validatePSM(PSM, buyerHeader)) {
            buyerHeader.label = "Transferee(s)";
        }
        const length = buyerHeader.subItems.length;
        buyerHeader.addOptions.forEach((menuElement: MenuItemType) => { menuElement.navigate.controller.tabNumber = length + 1 });
    }
    let sellerHeader = menu.find(menuItem => menuItem.id === "Seller")
    if (sellerHeader && validatePSM(PSM, sellerHeader)) {
        const sellerInfo = processor.getVendorInformation();
        sellerHeader.subItems = sellerInfo.map((val, index) => displayVendor(val, index, sellerInfo.length))
        if (isTitleTransfer && validatePSM(PSM, sellerHeader)) {
            sellerHeader.label = "Transferor(s)";
        }
        const length = sellerHeader.subItems.length;
        sellerHeader.addOptions.forEach((menuElement: MenuItemType) => { menuElement.navigate.controller.tabNumber = length + 1 })
    }
    if (PSM === "S") {
        if (sellerHeader) {
            ProperMenu.push(sellerHeader);
        }
        if (buyerHeader) {
            ProperMenu.push(buyerHeader);
        }
    } else {
        if (buyerHeader) {
            ProperMenu.push(buyerHeader);
        }
        if (sellerHeader) {
            ProperMenu.push(sellerHeader);
        }
    }
    if(PSM !== "M"){
        ProperMenu.push(newSolicitor)
    }
    let thirdParty = menu.find(menuItem => menuItem.id === "Third")
    if (thirdParty && validatePSM(PSM, thirdParty)) {
        const allThirdParty = processor.getThirdPartyInfo();
        const otherParties = allThirdParty.filter(node => ["OtherParty"].indexOf(node.personType) !== -1);
        const theRestParties = allThirdParty.filter(node => ["OtherParty"].indexOf(node.personType) === -1);
        const otherPartiesSubItems = otherParties.map((data, index) => { return displayPeople(data, index, processor); });
        const theRestPartiesSubItems = theRestParties.map((data, index) => { return displayPeople(data, index, processor); });
        thirdParty.subItems = [...theRestPartiesSubItems, ...otherPartiesSubItems];
        ProperMenu.push(thirdParty);
    }
    
    const diligence = menu.find(menuItem => menuItem.label === "Due Diligence")
    if (diligence) {
        ProperMenu.push(diligence);
    }

    let IssuesHeader = menu.find(menuItem => menuItem.id === "Issues")
    if (IssuesHeader && validatePSM(PSM, IssuesHeader)) {
    //     var issueSubItems = IssuesHeader.subItems;
    //     let newSubItems: Array<MenuItemType> = [];
    //     for (let i = 0; i < issueSubItems.length; i++) {
    //         let s = issueSubItems[i];
    //         if (validatePSM(PSM, s)) {
    //             newSubItems.push(s);
    //         }
    //     }
    //     IssuesHeader.subItems = newSubItems;
        const issueCount = processor.getDefectInformation()
            .filter((defect) => {
                const issueLabel = (defect.name || defect.Summary || defect.Name || "").trim();
                const isSimilarName = defect.SimilarName === "1";
                return issueLabel.length > 0 && !isSimilarName;
            }).length;
        IssuesHeader.params = {badgetext: issueCount.toString()};
        ProperMenu.push(IssuesHeader);
    }
    
    const requisitionHeader = menu.find(menuItem => menuItem.id === "Requisition")
    if (requisitionHeader) {
        setIssueLabel(requisitionHeader, PSM);
        ProperMenu.push(requisitionHeader);
    }
    const objectionHeader = menu.find(menuItem => menuItem.id === "Objection")
    if (objectionHeader) {
        setIssueLabel(objectionHeader, PSM);
        ProperMenu.push(objectionHeader);
    }
    const trustLetterMBHeader = menu.find(menuItem => menuItem.id === "TrustLetterMB")
    if (trustLetterMBHeader) {
        setIssueLabel(trustLetterMBHeader, PSM);
        ProperMenu.push(trustLetterMBHeader);
    }
    const trustLetterSKHeader = menu.find(menuItem => menuItem.id === "TrustLetterSK")
    if (trustLetterSKHeader) {
        if(PSM === "P") trustLetterSKHeader.label = "Trust Letter Reconciliation";
        ProperMenu.push(trustLetterSKHeader);
    }
    const trustLetterHeader = menu.find(menuItem => menuItem.id === "TrustLetter")
    if (trustLetterHeader) {
        ProperMenu.push(trustLetterHeader);
    }
    const descriptionHeader = menu.find(menuItem => menuItem.id === "Description")
    if (descriptionHeader) {
        if(PSM === "S") descriptionHeader.label = "Response Items";
        ProperMenu.push(descriptionHeader);
    }
    const titleMemorandumHeader = menu.find(menuItem => menuItem.id === "TitleMemorandum")
    if (titleMemorandumHeader) {
        ProperMenu.push(titleMemorandumHeader);
    }
    const undertakingResponseHeader = menu.find(menuItem => menuItem.id === "Undertaking")
    if (undertakingResponseHeader) {
        setIssueLabel(undertakingResponseHeader, PSM);
        ProperMenu.push(undertakingResponseHeader);
    }

    let mortgageHeader = menu.find(menuItem => menuItem.label === "Mortgage")
    if (mortgageHeader && validatePSM(PSM, mortgageHeader)) {
        const regMortgages = processor.getMortgageInformation();
        const mortgageSubItems = regMortgages.map((data, index) => { return displayMortgage(data, index, id, regMortgages.length); }).concat(
            processor.getDefectMortgages().map((data, index) => { return displayMortgage(data, index, id); })
        );
        mortgageHeader.subItems = mortgageSubItems;
        ProperMenu.push(mortgageHeader);
    }
    const titleInsuranceHeader = findMenuItem(menu, "Title Insurance");
    if(titleInsuranceHeader && validatePSM(PSM, titleInsuranceHeader)){
        ProperMenu.push(titleInsuranceHeader);
    }
    const fireInsuranceHeader = findMenuItem(menu, "Fire Insurance");
    const isFireInsuranceExcluded = PSM === "S" && (province === "BC" || province === "NS");
    if (fireInsuranceHeader && validatePSM(PSM, fireInsuranceHeader) && !isFireInsuranceExcluded) {
        ProperMenu.push(fireInsuranceHeader);
    }
    const matterHeader = menu.find(menuItem => menuItem.id === "Matters")
    if (matterHeader) {
        loadMatterInfo(processor.getDefectInformation(), matterHeader);
        ProperMenu.push(matterHeader);
    }
    const registration = menu.find(menuItem => menuItem.id === "reg_sub")
    if (registration && validatePSM(PSM, registration)) {
        let newSubItems: Array<MenuItemType> = processor.getRegistrationDetails().map(displayDefect);
        for (let i = 0; i < newSubItems.length; i++) {
            let s = newSubItems[i];
            registration.subItems.push(s);
        }
        ProperMenu.push(registration);
    }
    const registrationNoSub = menu.find(menuItem => menuItem.id === "reg_no_sub")
    if (registrationNoSub && validatePSM(PSM, registrationNoSub)) {
        ProperMenu.push(registrationNoSub);
    }

    let financialHeader = menu.find(menuItem => menuItem.label === "Financial")
    if (financialHeader && validatePSM(PSM, financialHeader)) {
        updateFinancial(processor, processor.getFinancialInformation(), financialHeader, isTitleTransfer);
        ProperMenu.push(financialHeader);
    }
}

function loadMatterInfo(matterInfo: Array<Record<string, string>>, matterHeader: MenuItemType) {
    let allMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "All");
    let outstandingMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "Outstanding");
    let resolvedMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "Resolved");
    var counters = {
        all: matterInfo.length,
        outstanding: 0,
        resolved: 0,
    }
    for (let matter of matterInfo) {
        if (matter.CheckResolved === '1') {
            counters.resolved += 1;
        } else {
            counters.outstanding += 1;
        }
    }
    if (allMatters)
        allMatters.params["counter"] = String(counters.all);
    if (outstandingMatters)
        outstandingMatters.params["counter"] = String(counters.outstanding);
    if (resolvedMatters)
        resolvedMatters.params["counter"] = String(counters.resolved);
}

function initMenu(menu: Array<MenuItemType>, params: Record<string, string>): Array<MenuItemType> {
    return menu.map(menuItem => initMenuItem(menuItem, params))
}

function initMenuItem(menuItem: MenuItemType, params: Record<string, string>): MenuItemType {
    if (menuItem?.navigate?.params?.id && menuItem.navigate.params.id === CONST.uninitialized) {
        menuItem.navigate.params.id = params.id
    }
    if (menuItem?.navigate?.params?.PSM && menuItem.navigate.params.PSM === CONST.uninitialized) {

        menuItem.navigate.params.PSM = params.PSM
    }
    if (menuItem.subItems) {
        menuItem.subItems = initMenu(menuItem.subItems, params);
        const tempSet: Set<string> = new Set(), tempArr: string[] = [];
        menuItem.subItems.forEach((item) => { if (item.navigate?.controller?.tabName) { tempSet.add(item.navigate.controller.tabName)} });
        tempSet.forEach((v) => tempArr.push(v));
        menuItem.controllerTabNames = tempArr;
    }
    if (menuItem.addOptions) {
        menuItem.addOptions = initMenu(menuItem.addOptions, params);
    }
    return menuItem;
}

const newFileMenu: ((list: Array<MenuItemType>) => Array<MenuItemType>) = (list) => structuredClone(list);

function displayMortgage(mortgage: MortgageType, index: number, appID: string, final?: number): MenuItemType {
    let navigation: NavObjectType;
    switch (mortgage.type) {
        case "Discharge":
        case "Assumed":
        case "Remaining":
            navigation = {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 0,
                },
                action: "ReactShell.ReactEditExistingMortgage",
                actionParam: mortgage.position,
            }
            break;
        case "Postpone":
            break;
        default:
            navigation = {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": appID,
                    "PSM": mortgage.PSM,
                },
                controller: {
                    tabName: "Mortgages",
                    tabNumber: index + 1,
                },
            }
    }
    return {
        label: mortgage.Lender ? mortgage.Lender : "+ Lender",
        navigate: navigation,
        params: {
            badgetext: mortgage.type,
            badgeCategory: "Mortgage",
            final: String(typeof final === 'number' && index === final - 1),
        },
        addOptions: [],
        type: MenuItemCategory.Default,
    }
}
function displayPeople(person: PersonType, index: number, livedataRoot: RPWDataReader): MenuItemType {
    const personItem: MenuItemType = {
        label: person.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId[person.personType],
            },
        },
        params: {
            badgetext: ""
        },
        addOptions: [],
        type: MenuItemCategory.AdditionalParties
    };
    switch (person.personType) {
        case 'Conveyancer':
            personItem.params.badgetext = "Conveyancer";
            break;
        case 'InsuranceAgent':
            personItem.params.badgetext = "Fire Ins.";
            break;
        case 'MortgageBroker':
            personItem.params.badgetext = "Mtg Broker";
            break;
        case 'PurchaserRealEstateAgent': {
            let t = "Realtor";
            const appcode = livedataRoot.getAppCode();
            if (appcode === "BC") {
                t = "S Agent";
            } else if (appcode === "NS" || appcode === "SK" || appcode === "MB") {
                t = "P. Realtor"
            }
            personItem.params.badgetext = t;
            break;
        }
        case 'RealEstateAgent': {
            let t = "Realtor";
            const appcode = livedataRoot.getAppCode();
            if (appcode === "BC") {
                t = "L Agent";
            } else if (appcode === "NS" || appcode === "SK" || appcode === "MB") {
                t = "V. Realtor"
            }
            personItem.params.badgetext = t;
            break;
        }
        case "OtherParty":
            switch (person.OtherPartyType) {
                case "Relocation Company":
                    personItem.params.badgetext = "Relocation Co.";
                    break;
                case "Referral":
                    personItem.params.badgetext = "Referral";
                    break;
                default:
                    personItem.params.badgetext = person.OtherPartyType.substring(0, 14);
                    break;
            }
            personItem.navigate.controller.tabNumber = index + 1;
            break;
    }
    return personItem;
}

function displayVendor(vendor: Record<string, string>, index: number, final?: number): MenuItemType {
    return {
        label: vendor.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId.Transferor,
                tabNumber: index + 1,
            },
            scrollToId: "contentHolder"
        },
        params: {
            agreement: vendor.IsVendor,
            title: vendor.OnTitle,
            final: String(typeof final === 'number' && index === final - 1),
        },
        addOptions: [],
        type: MenuItemCategory.Person
    }
}

function updateContract(processor: RPWDataReader, contract: ContractType, contractHeader: MenuItemType): MenuItemType {
    let PSM = processor.getPSM();
    let newSubItems: Array<MenuItemType> = [];
    let subItems = contractHeader.subItems;
    for (let i = 0; i < subItems.length; i++) {
        let s = subItems[i];
        if (validatePSM(PSM, s)) {
            newSubItems.push(s);
        }
    }

    contractHeader.subItems = newSubItems;
    return contractHeader
}

function updateFinancial(processor: RPWDataReader, finance: FinanceType, financeHeader: MenuItemType, isTitleTransfer: boolean): MenuItemType {
    let PSM = processor.getPSM();
    let newSubItems: Array<MenuItemType> = [];
    let subItems = financeHeader.subItems;
    for (let i = 0; i < subItems.length; i++) {
        let s = subItems[i];
        if (isTitleTransfer && s.TitleTransferExclude) {
            continue;
        }
        if (validatePSM(PSM, s)) {
            newSubItems.push(s);
        }
    }
    financeHeader.subItems = newSubItems;
    return financeHeader
}

function displayPurchaser(purchaser: PurchaserType, index: number, final?: number): MenuItemType {
    return {
        label: purchaser.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId.Transferee,
                tabNumber: index + 1,
            },
            scrollToId: "contentHolder"
        },
        params: {
            agreement: purchaser.IsPurchaser,
            title: purchaser.OnTitle,
            final: String(typeof final === 'number' && index === final - 1)
        },
        addOptions: [],
        type: MenuItemCategory.Person
    }
}

function displayDefect(defect: RegistrationType): MenuItemType {
    return {
        label: defect.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        addOptions: [],
        type: MenuItemCategory.Default,
    }
}



export const NavFileContainer = (props: {
    setDrawerState: (tab: fileTabVal) => void,
    drawerState: fileTabVal,
    page: NavObjectType,
}) => {
    const dispatch = useDispatch();
    const [queueManager] = useState<EventQueueManager>(() => new EventQueueManager());
    const SessionInfo = useAppSelector((state: lddStateObject) => state.SessionInfo);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const dataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    const msgId = dataReaderObj.getVIPInfoMsgID();
    const sideMenuReload = useAppSelector((state) => state.SideMenuReload);
    const processor: RPWDataReader = getDataReader(livedataRootContainer?.dataRoot);
    const userPreferences = useAppSelector((state: lddStateObject) => state.UserPreferences);
    const openDocumentsAutomatically = userPreferences?.openDocumentsAutomatically ?? true;
    const province = SessionInfo.appProvinceShort;
    const [useStandardDocuments, setUseStandardDocuments] = useState(
        livedataRootContainer.dataRoot?.getAttribute("UseStandardDocuments") === "1"
    );
    const [useWesternProtocol, setUseWesternProtocol] = useState(
        livedataRootContainer.dataRoot?.getAttribute("UseWesternProtocol") === "1"
    );
    useEffect(() => {
        const tab = props.page.controller?.tabName;
        if (tab === "Documents") {
            if (province === "ON") {
                setUseStandardDocuments(livedataRootContainer.dataRoot?.getAttribute("UseStandardDocuments") === "1");
            } else{
                setUseWesternProtocol(livedataRootContainer.dataRoot?.getAttribute("UseWesternProtocol") === "1");
            }
        }
    }, [props.page.controller?.tabName, livedataRootContainer.dataRoot]);

    // states
    const [menu, setMenu] = useState<Array<MenuItemType>>([]);
    const [openMenu, setOpenMenu] = useState<Record<string, boolean>>({});
    const [defaultKey, setDefaultKey] = useState<string>(`${props.page?.controller?.tabName}-${props.page?.controller?.tabNumber}-${props.page?.actionParam}-Summary`);
    const isCollege = SessionInfo.firm?.IsCollege;

    const handleSetDrawer = (tab: fileTabVal) => {
        props.setDrawerState(tab);
    }

    const drawerToggleMenu = (menuItem) => () => {
        const newOpenMenu = { ...openMenu };
        if (menuItem in openMenu) {
            newOpenMenu[menuItem] = !newOpenMenu[menuItem];
        } else {
            newOpenMenu[menuItem] = true;
        }
        setOpenMenu(newOpenMenu);
    }

    // load clientconnect beta user
    // useEffect(() => {
    //     const url = 'js/clientConnectBetaUsers.json';
    //     fetch(url, { method: 'GET', cache: "default" })
    //         .then((result) => {
    //             result.text().then((s) => {
    //                 setBetaUsers(JSON.parse(s).allowedFirms)
    //             }).catch(err => {
    //                 console.log('error', err)
    //             });
    //         })
    //         .catch(error => {
    //             console.log('error', error)
    //         });
    // }, []);

    // Load and rebuild the side menu when navigation context changes.
    // `livedataRootContainer` as Redux selector target via `useAppSelector`, changes with the iframe dataRoot;
    // useEffect apply dependency triggers (e.g. `getDocumentMergeDate`, `getDocumentSignCheckBox`) and `setMenu(...)` for a re-render.
    useEffect(() => {
        const promise = () => new Promise((resolve, reject) => {
            currentPageMenu({ dataroot: livedataRootContainer?.dataRoot, page: props.page, filetab: props.drawerState })
            .then(pageMenu => {
                const hydrateDocumentControl = (items: Array<MenuItemType>): Array<MenuItemType> => {
                    const [
                        DocumentMergeDate,
                        FirmCitySign,
                        FirmMunicipalitySign,
                        DocumentMergeDateDay,
                        DocumentMergeDateMonth,
                        DocumentMergeDateYear,
                    ] = processor.getDocumentMergeDate?.() || [];

                    const formatDocDate = (raw?: string): string => {
                        const formatDate = (raw || "").trim();
                        if (!formatDate) return "";

                        // Format date as DD/MM/YYYY for display
                        const m = formatDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
                        if (m) {
                            const year = Number(m[1]);
                            const month = Number(m[2]);
                            const day = Number(m[3]);
                            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                            const mon = monthNames[month - 1];
                            if (year && mon && day) return `${day}/${mon}/${year}`;
                        }

                        // Fallback to Date parsing
                        const d = new Date(formatDate);
                        if (!Number.isNaN(d.getTime())) {
                            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                            return `${d.getDate()}/${monthNames[d.getMonth()]}/${d.getFullYear()}`;
                        }

                        return formatDate;
                    }

                    const [
                        ElectronicSignature,
                        DeliveryNotation,
                        isRemoteSigning,
                    ] = processor.getDocumentSignCheckBox?.() || [];

                    const isOnFlag = (raw?: string): boolean => {
                        const s = (raw || "").trim().toLowerCase();
                        return s === "1";
                    }

                    const signatureDate =
                        DocumentMergeDateDay || DocumentMergeDateMonth || DocumentMergeDateYear
                            ? `This ${DocumentMergeDateDay || "(day)"} day of ${DocumentMergeDateMonth || "(month)"}, ${DocumentMergeDateYear || "(year)"}`
                            : "(blank)";

                    const formattedDocumentDate = formatDocDate(DocumentMergeDate);

                    const documentControlPairs: Array<[string, string | undefined]> = [
                        ["Document Date", formattedDocumentDate || DocumentMergeDate],
                        ["Dated at", `${FirmCitySign || "(city)"} in the ${FirmMunicipalitySign || "(municipality)"}`],
                        ["Signature Date", signatureDate]

                    ];

                    const DocumentSignCheckBox: Array<[string, string | undefined]> = [ // Display selected delivery method as string in container          
                        ["Remote Signing", isRemoteSigning],
                        ["Electronic Signature", ElectronicSignature],
                    ];

                    const documentControlJsx = documentControlPairs.flatMap(([label, rawValue]) => {
                        const valueText = rawValue || "(blank)";
                        return [
                            { tag: Form.Label, text: label },
                            {
                                tag: Form.Control,
                                text: valueText,
                                props: {
                                    as: "div",
                                    plaintext: true,
                                    readOnly: true,
                                },
                            },
                        ];
                    });

                    // Render checkbox fields as badges, with styling based on raw value ("1" => enabled), apply to Document Control ->
                    // Electronic Signature, Delivery Notation, Remote Signing
                    const deliveryNotationPlain = deliveryNotationToPlainText(DeliveryNotation || '').trim();
                    const buildDocControlBadge = (text: string, enabled: boolean) => ({
                        tag: Badge,
                        text,
                        props: { bg: enabled ? "info" : "secondary", pill: true },
                        className: "text-truncate",
                    });
                    const hasSelectedDeliveryCheckbox = DocumentSignCheckBox.some(([, rawValue]) => isOnFlag(rawValue));
                    const docSignCheckBoxJsx = [
                        ...(deliveryNotationPlain
                            ? [buildDocControlBadge(deliveryNotationPlain, true)] // Any non-empty delivery notation should be highlighted.
                            : []),
                        ...(!deliveryNotationPlain
                            ? [buildDocControlBadge("No Delivery Type", true)]
                            : []),
                        ...DocumentSignCheckBox.map(([label, rawValue]) => buildDocControlBadge(label, isOnFlag(rawValue))),
                    ];

                    return items.map((item) => {
                        const next: MenuItemType = { ...item };

                        if (next.id === "DocumentControlBanner") {
                            next.params = {
                                ...(next.params || {}),
                                variant: next.params?.variant || "info",
                                text: "",
                            };
                            next.jsxParams = {
                                ...(next.jsxParams || ({} as any)),
                                variant: next.params?.variant || "info",
                                jsx: [...documentControlJsx, ...docSignCheckBoxJsx],
                            };
                        }

                        if (next.subItems) next.subItems = hydrateDocumentControl(next.subItems);
                        if (next.addOptions) next.addOptions = hydrateDocumentControl(next.addOptions);
                        if (next.dropdownOptions) next.dropdownOptions = hydrateDocumentControl(next.dropdownOptions);

                        return next;
                    });
                };

                const decoratedMenu: Array<MenuItemType> =
                    (props.drawerState === fileTabVal.DOCUMENTS)
                        ? hydrateDocumentControl(pageMenu)
                        : pageMenu;
                setMenu(decoratedMenu);
                if(props.drawerState === fileTabVal.NEWHOME && msgId !== null){
                    const checkEsignAvailability = async () => {
                        try {
                            const response = await axios.get(`${window.location.origin}/docsigning/info/inbox/getPostingMsgInfo/${-1}?msgId=${msgId}&SessionID=${SessionInfo.sid}`, {
                                responseType: "json",
                            });
                            if  (response.data.message === "success") {
                                if (response.data.data.recordset.filter((doc: any) => doc.MsgID.toString() === msgId).some((doc: any) => doc.NeedSign === true)) {
                                    setMenu(decoratedMenu);
                                } else {
                                    setMenu([{...pageMenu[0], subItems: [pageMenu[0].subItems[0], pageMenu[0].subItems[1]]}]);
                                }
                            }
                        } catch (error) {
                            console.log("error");
                        }
                    }   
                    checkEsignAvailability()
                } else {
                    setMenu(decoratedMenu);
                }
                if (pageMenu.length > 0) {
                    const label = props.page.label;
                    setDefaultKey(`${props.page?.controller?.tabName}-${props.page?.controller?.tabNumber}-${props.page?.actionParam}-${label}`);
                }
                
                // auto-expand, if focused list is long
                const findMenu = decoratedMenu.find((menu) => menu.controllerTabNames?.includes(props.page.controller?.tabName));
                if (findMenu && !openMenu[findMenu.label]) {
                    const newOpenMenu = { ...openMenu };
                    newOpenMenu[findMenu.label] = true;
                    setOpenMenu(newOpenMenu);
                }
                resolve(true);
            })
            .catch(error => {
                reject(error);
            });
        });
        queueManager.enque(promise);
    }, [props.drawerState, livedataRootContainer, sideMenuReload, props.page]);

    if (!(props.page.params && props.page.params['formasp'] === 'purfileedit')) {
        return (<></>)
    }

    return (
        <div className="fileNavContainer">
            <Navbar className="nav-file-tabs">
                <FileTabButton
                    setValue={fileTabVal.SUMMARY}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-duotone fa-earth-americas"}
                    title={"Summary"}
                />
                <FileTabButton
                    setValue={fileTabVal.DETAILS}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-duotone fa-chart-simple-horizontal"}
                    title={"Details"}
                />
                <FileTabButton
                    setValue={fileTabVal.DOCUMENTS}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-duotone fa-memo-pad"}
                    title={"Documents"}
                />
                {
                    livedataRootContainer?.dataRoot &&
                    // (SessionInfo.betaUser["ClientConnect"]?.indexOf(firmID) !== -1 || SessionInfo.betaUser["ClientConnect"]?.indexOf(appCode) !== -1) &&
                    <FileTabButton
                        setValue={fileTabVal.CLIENTPORTAL}
                        setMenuState={handleSetDrawer}
                        stateValue={props.drawerState}
                        icon={"fak fa-connect-solid"}
                        title={"Client"}
                        disable={isCollege}
                    />
                }
                {
                    livedataRootContainer?.dataRoot &&
                    (SessionInfo.appProvinceShort === "ON" || SessionInfo.appProvinceShort === "BC") &&
                    (processor.getPSM() === "P" && processor.getNewHome() === "0") &&
                    <FileTabButton
                        setValue={fileTabVal.NEWHOME}
                        setMenuState={handleSetDrawer}
                        stateValue={props.drawerState}
                        icon={"fak fa-connect-solid"}
                        title={"NewHome"}
                    />
                }
            </Navbar>
            {menu.length > 0 && <>
                {props.drawerState === fileTabVal.CLIENTPORTAL ? (
                    <Tab.Container>
                        <ListGroup className="nav-file-content">
                            {menu.map(navItem(openMenu, drawerToggleMenu, 0))}
                        </ListGroup>
                    </Tab.Container>
                ) : (
                    <Tab.Container activeKey={defaultKey}>
                    <ListGroup className="flex-column nav-file-content">
                        <Nav
                             className="flex-column"
                            style={props.drawerState === fileTabVal.EMPTY ? { display: "none" } : {}} >
                            {props.drawerState === fileTabVal.DOCUMENTS ? (() => {
                                const formsIdx = menu.findIndex(item => item.label === "Forms & Stationery");
                                const before = formsIdx > -1 ? menu.slice(0, formsIdx) : menu;
                                const after = formsIdx > -1 ? menu.slice(formsIdx) : [];
                                return (
                                    <>
                                        {before.map(navItem(openMenu, drawerToggleMenu, 0, props.page))}
                                        <DocumentSetup
                                            province={province}
                                            livedataDataRoot={livedataRootContainer?.dataRoot}
                                            processor={processor}
                                            useStandardDocuments={useStandardDocuments}
                                            setUseStandardDocuments={setUseStandardDocuments}
                                            useWesternProtocol={useWesternProtocol}
                                            setUseWesternProtocol={setUseWesternProtocol}
                                            openDocumentsAutomatically={openDocumentsAutomatically}
                                            userPreferences={userPreferences}
                                            SessionInfo={SessionInfo}
                                            dispatch={dispatch}
                                        />
                                        {after.map(navItem(openMenu, drawerToggleMenu, 0, props.page))}
                                    </>
                                );
                            })() : menu.map(navItem(openMenu, drawerToggleMenu, 0, props.page))}
                        </Nav>
                    </ListGroup>
                </Tab.Container>
                )}
            </>}
            <DocsDropbox 
                fileLocation = {props.page.params.mortgageImportFile}
            />
        </div>
    )
}